// Entrepreneur portal auth helpers
const TOKEN_KEY = "besson_portal_token";
const ENT_KEY = "besson_portal_entrepreneur";

export function setPortalAuth(token, entrepreneur) {
  localStorage.setItem(TOKEN_KEY, token);
  if (entrepreneur) localStorage.setItem(ENT_KEY, JSON.stringify(entrepreneur));
}

export function clearPortalAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ENT_KEY);
}

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getPortalEntrepreneur() {
  try { return JSON.parse(localStorage.getItem(ENT_KEY) || "null"); }
  catch { return null; }
}

// Alias used by the public Header
export const getPortalUser = getPortalEntrepreneur;

export function isPortalAuthed() {
  return Boolean(getPortalToken());
}
